import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  TablePagination,
  Popover,
  CircularProgress,
} from "@material-ui/core";
import { useState } from "react";
import { getReportSource } from "../network_requests";
import ReportSource from "./ReportSource";

export default function ReportTable(props) {
  const rows = props.rows;
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [reportDetails, setReportDetails] = useState([]);
  const [columns, setColumns] = useState([]);
  const [load, setLoad] = useState(false);
  return (
    <>
      <TableContainer component={Paper}>
        <Table size="small" style={{ tableLayout: "fixed" }} stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Data source</TableCell>
              <TableCell align="right">Companies having</TableCell>
              <TableCell align="right">Companies missing</TableCell>
              <TableCell align="right">Date</TableCell>
              <TableCell align="right">Source</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <TableRow key={row.Invitation}>
                  <TableCell component="th" scope="row">
                    {row.Data_source}
                  </TableCell>
                  <TableCell align="right">{row.companies_having}</TableCell>
                  <TableCell align="right">{row.companies_missing}</TableCell>
                  <TableCell align="right">{row.Date}</TableCell>
                  <TableCell align="right">
                    <div
                      onClick={async (event) => {
                        setLoad(true);
                        setReportDetails([]);
                        setAnchorEl(event.currentTarget);
                        const data = await getReportSource(row.Source);
                        setReportDetails(data?.Values);
                        console.log(data);
                        setColumns(data?.columns);
                        setLoad(false);
                      }}
                    >
                      {row.Source}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TableRow>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
            colSpan={3}
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={(event, page_) => {
              setPage(page_);
            }}
            onChangeRowsPerPage={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}
          />
        </TableRow>
      </TableContainer>
      <Popover
        open={Boolean(anchorEl)}
        anchorReference="anchorPosition"
        anchorPosition={{ top: 20, left: 100 }}
        onClose={() => {
          setAnchorEl(null);
        }}
        style={{
          maxWidth: "90%",
        }}
        // anchorOrigin={{
        //   vertical: "top",
        //   horizontal: "center",
        // }}
        // transformOrigin={{
        //   vertical: "top",
        //   horizontal: "center",
        // }}
      >
        {load ? (
          <div
            style={{
              minHeight: "50vh",
              minWidth: "50vw",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <ReportSource rows={reportDetails} columns={columns} />
        )}
      </Popover>
    </>
  );
}
